import type { Locale } from '@core/Entities/Locale/Locale.entity';
import { ukLocale } from '@core/Utils/Intl/MappedLocales';

export const getFormattedDate = (value: Date, _?: Locale) => {
  const dateObj = new Date(value);
  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  };

  const formatter = new Intl.DateTimeFormat(ukLocale, options);

  const formattedDate = formatter.format(dateObj);
  return formattedDate;
};
